module.exports = __webpack_public_path__ + "img/thumbnail_RedKangaroo_f_normal.8696fe1d.png";